export default __webpack_public_path__ + "static/media/fitnessGuideScreenshot.4a8d4cbb.png";